<template>
  <div class="picList">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      class="list"
      :immediate-check="true"
    >
      <div v-for="(item, index) in list" :key="index + 1000">
        <!-- <div class="date">{{ item.date }}</div> -->
        <div class="pic">
          <div
            v-if="pic"
            class="pic_item"
            v-for="(pic, _index) in item.picList"
            :key="_index"
          >
            <ImageProxy
              :url="pic.url"
              :index="index"
              :_index="_index"
              :click="handleClick"
            />
            <div class="time">{{ pic.cdate }}</div>
          </div>
          <div v-else class="pic_item"></div>
        </div>
      </div>
    </van-list>

    <AI v-if="visible" @cancel="handleCancel" :url="url" :time="time" />
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import AI from '@/components/AI'

export default {
  components: {
    AI,
  },
  props: {
    hasDeviceChange: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      oldList: [],
      list: [],
      loading: false,
      finished: false,
      page: 1,
      pageSize: 5,
      totalPages: 0,
      isFirst: true,
      visible: false,
      url: '',
    }
  },

  watch: {
    hasDeviceChange(v) {
      if (v) {
        const no = localStorage.getItem('no')
        this.no = no
        this.list = []
        this.oldList = []
        this.onRefresh()
      }
    },

    refreshing(bl) {
      bl && this.onRefresh()
    },
  },

  destroyed() {
    this.list = []
  },

  mounted() {
    const no = localStorage.getItem('no')
    if (no == 1000000342) {
      this.visible = false
    }
  },

  methods: {
    async onRefresh() {
      this.page = 1
      this.isFirst = true
      this.oldList = []
      await this.onLoad()
    },

    // 获取摄像头下的图片列表
    async getPicture() {
      await this.$toast.loading({
        message: this.$t('common.loading'),
        forbidClick: true,
        duration: 0,
      })

      try {
        this.isFirst = false
        const { page, pageSize } = this
        const res = await this.$api.getCameraPicture({
          gatewayNo: localStorage.getItem('no'),
          page,
          pageSize,
        })
        this.$toast.clear()

        const oldList = [...this.oldList]
        const list = res.list

        if (list && list.length) {
          let timeGroup = new Set()
          const newList = [...oldList.concat(list)]
          this.oldList = [...newList]

          // 合在一起后再进行日期分组
          newList.map((item) => {
            if (item.date == null) {
              timeGroup.add(item.cdate.split(' ')[0])
            } else {
              timeGroup.add(item.date)
            }
          })
          timeGroup = Array.from(timeGroup)
          const newTimeGroup = []
          timeGroup.map((item) => {
            newTimeGroup.push({
              date: item,
              picList: [],
            })
          })

          newTimeGroup.map((item) => {
            newList.map((_item) => {
              let date = ''
              if (_item.date == null) {
                date = _item.cdate.split(' ')[0]
              } else {
                date = _item.date
              }

              if (item.date === date) {
                item.picList.push({
                  ..._item,
                })
              }
            })
          })

          newTimeGroup.map((item) => {
            if (item.picList && item.picList.length) {
              const count = 3
              const m = item.picList.length % count
              if (m) {
                const l = count - m
                let arr = {}
                arr.length = l
                arr = Array.from(arr)
                arr.map(() => {
                  item.picList.push(null)
                })
              }
            }
          })

          this.list = [...newTimeGroup]

          console.log('list:', this.list, this.finished)

          this.totalPages = res.pages
          this.page++
        }
      } catch (err) {
        this.$toast.clear()
        console.error(err)
      }
    },

    // 下拉请求数据
    async onLoad() {
      this.loading = true

      if (this.isFirst) {
        await this.getPicture()
      } else {
        this.page <= this.totalPages && (await this.getPicture())
      }

      console.log('下滑了:', this.finished, this.page, this.list)

      this.loading = false
      if (
        this.page >= this.totalPages ||
        (this.page === 1 && !this.list.length)
      ) {
        this.finished = true
      } else {
        this.finished = false
      }
    },

    /**
     * @description 图片点击
     * @param {number} index list中的下标
     * @param {number} _index list中下标对象中的picList中的第几个
     */
    handleClick(index, _index) {
      const images = []
      this.list[index].picList.map((item) => {
        item && images.push(item)
      })

      const { url, cdate, fileId } = images[_index]

      this.$router.push({
        path: '/ai',
        query: {
          imgUrl: url,
          time: cdate,
          fileId,
        },
      })
    },

    handleCancel() {
      console.log('cancel')
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.picList {
  min-height: 100%;

  .list {
  }

  .date {
    line-height: 40px;
    text-align: left;
  }
  .pic {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

    .pic_item {
      width: 49%;
      // height: 100px;
      margin-bottom: 0.3rem;
      overflow: hidden;
    }

    .time {
      text-align: center;
    }
  }
}
</style>
